import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { getColorScheme } from '../../colors';
import { pxToRem } from '../../../../utils';
import getBorderFocusStyles from '../../getBorderFocusStyles';
import { default as ToolbarMenuItem } from '../../../../components/Toolbar/ToolbarMenuItem';
import submenuIndicatorUrl from './submenuIndicatorUrl';
import activeIndicatorUrl from './activeIndicatorUrl';
var toolbarMenuItemStyles = {
  root: function root(_ref) {
    var _hover, _ref2;

    var p = _ref.props,
        v = _ref.variables,
        siteVariables = _ref.theme.siteVariables;
    var colors = getColorScheme(v.colorScheme);
    var borderFocusStyles = getBorderFocusStyles({
      siteVariables: siteVariables,
      borderRadius: 0
    });
    return Object.assign({
      position: 'relative',
      color: v.menuItemForeground || colors.foreground1,
      borderWidth: v.menuBorderWidth,
      backgroundColor: 'transparent',
      borderColor: 'transparent',
      display: 'flex',
      alignItems: 'center',
      textAlign: 'left',
      width: '100%',
      maxWidth: '100%',
      padding: v.menuItemPadding,
      cursor: 'pointer',
      ':focus': {
        outline: 0
      },
      ':hover': (_hover = {
        color: v.menuItemForegroundHover || colors.menuItemForegroundHover,
        backgroundColor: v.menuItemBackgroundHover || colors.menuItemBackgroundHover
      }, _defineProperty(_hover, "& .".concat(ToolbarMenuItem.slotClassNames.submenuIndicator), {
        backgroundImage: submenuIndicatorUrl(v.menuItemForegroundHover || colors.menuItemForegroundHover)
      }), _defineProperty(_hover, "& .".concat(ToolbarMenuItem.slotClassNames.activeIndicator), {
        backgroundImage: activeIndicatorUrl(v.menuItemForegroundHover || colors.menuItemForegroundHover)
      }), _hover),
      ':focus-visible': borderFocusStyles[':focus-visible']
    }, p.disabled && (_ref2 = {
      cursor: 'default',
      color: v.menuItemForegroundDisabled || colors.foregroundDisabled1,
      backgroundColor: v.menuItemBackgroundDisabled
    }, _defineProperty(_ref2, "& .".concat(ToolbarMenuItem.slotClassNames.submenuIndicator), {
      backgroundImage: submenuIndicatorUrl(v.menuItemForegroundDisabled || colors.foregroundDisabled1)
    }), _defineProperty(_ref2, "& .".concat(ToolbarMenuItem.slotClassNames.activeIndicator), {
      backgroundImage: activeIndicatorUrl(v.menuItemForegroundDisabled || colors.foregroundDisabled1)
    }), _defineProperty(_ref2, ':hover', {// empty to overwrite all existing hover styles
    }), _ref2));
  },
  activeIndicator: function activeIndicator(_ref3) {
    var v = _ref3.variables;
    var colors = getColorScheme(v.colorScheme);
    return {
      backgroundImage: activeIndicatorUrl(v.menuItemForeground || colors.foreground1),
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      width: pxToRem(24),
      height: '100%',
      position: 'absolute',
      right: pxToRem(7)
    };
  },
  submenuIndicator: function submenuIndicator(_ref4) {
    var v = _ref4.variables,
        rtl = _ref4.rtl;
    var colors = getColorScheme(v.colorScheme);
    return Object.assign({
      backgroundImage: submenuIndicatorUrl(v.menuItemForeground || colors.foreground1),
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat'
    }, rtl && {
      transform: "scaleX(-1)"
    }, {
      width: pxToRem(16),
      height: '100%',
      position: 'absolute',
      right: pxToRem(7)
    });
  },
  wrapper: function wrapper() {
    return {
      display: 'block'
    };
  }
};
export default toolbarMenuItemStyles;